module.exports = __webpack_public_path__ + "img/frame (1).b4ecb251.jpg";